import React, {useState} from 'react'
import {ru} from '../../data/ru';
import {by} from '../../data/by';
import './answer.css'
// import './expert.css';
// import  './modal.css'
import {ReturnTextAndImg} from "../../test/CheckImg";
import API from "../../API";

const Answer = (props) => {
    let language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdSix : by.RoleIdSix;
    const api = new API();
    const {idQuestion, question, maxScore, answer} = props.additional;

    const [form, setForm] = useState({
        idQuestion: idQuestion,
        score: props.additional.score||0
    });

    const sendResults = (e) => {
        e.preventDefault();
        let resultJSON = {
            idQuestion: form.idQuestion,
            score: form.score,
        };
        api.sendCheckedResult(resultJSON).then(data => {
            props.additional.setQuestion(props.additional.isChecked);
            props.close()
        }).catch()
    }

    let answers = '';
    for(let prop in answer){
        answers+=answer[prop]+'\n'
    }

    let textQuestion = ReturnTextAndImg(question)
    return (
        <>
            <form onSubmit={e => sendResults(e)}>
                <div className='answer_text'><p className='answer_text'>{language.question}:</p>{textQuestion}</div>
                <p className='answer_text'>{language.studentAnswer}:</p>
                <pre className='answer_answer'>{answers}</pre>
                <p className='answer_text'>{language.maxScore}: {maxScore}</p>

                <p className='answer_text'>{language.score}: <input
                    type='number'
                    min={0}
                    max={maxScore}
                    className="answer_score"
                     // placeholder={language.enterNumberScore}
                    defaultValue={form.score}
                    onChange={e => setForm(current => {
                        current.score = e.target.value;
                        return current
                    })}
                /></p>
                <button className="answer_button"
                        value="Отправить"
                >{language.send}</button>
            </form>
        </>
    )
}
export default Answer;
